import clsx from "clsx"
import { FC } from "react"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuction } from "hooks/useAuction"
import { APP_ROUTES } from "utils/app-routes"
import { hapticFeedback } from "utils/hapticFeedback"
import { SideMenuAuctionClipPath } from "./ui/side-menu-auction-clip-path"
import { auctionIcon } from "assets/icons"
import styles from "./index.module.scss"

interface ISideMenuAuction {}

export const SideMenuAuction: FC<ISideMenuAuction> = () => {
  const { isActive, data } = useAuction()
  const { t } = useTranslation()

  return (
    <Link
      to={APP_ROUTES.AUCTION}
      className={clsx(styles.SideMenuAuction, {
        [styles.disabled]: !isActive
      })}
      onClick={() => {
        hapticFeedback()
      }}
    >
      <SideMenuAuctionClipPath />
      <img className={clsx(styles.SideMenuAuction_icon)} src={auctionIcon} />
      {isActive && <div className={clsx(styles.SideMenuAuction_blink)} />}
      {data?.auction?.status && (
        <div className={clsx(styles.SideMenuExpeditions_timer)}>
          {t(`auction.timer.title.short.${data.auction.status}`)}
        </div>
      )}
    </Link>
  )
}
